import { useLocation } from "react-router-dom";
import { SEO_PAGES } from "@/data/seoPages";
import { SeoLandingPage } from "@/components/landing/SeoLandingPage";

/**
 * Resolves the current pathname to a config in SEO_PAGES.
 * Router registers each slug as a static route pointing to <SeoPage />.
 */
export default function SeoPage() {
  const { pathname } = useLocation();
  const slug = pathname.replace(/^\//, "").replace(/\/$/, "");
  const config = SEO_PAGES[slug];
  if (!config) return null;
  return <SeoLandingPage config={config} />;
}
